import type { RouterOutputs } from "@repo/api";
import { useEffect } from "react";
import { useShallow } from "zustand/react/shallow";

import { api } from "~/lib/api";
import { useLoadingStore } from "~/stores/use-loading-store";
import { TerminalContext } from "../hooks/use-terminal";

export type Terminal = RouterOutputs["terminal"]["getTerminals"][number];

interface TerminalProviderProps {
  children: React.ReactNode;
}

export function TerminalProvider({ children }: TerminalProviderProps) {
  const { data: terminals, isFetching: isTerminalsLoading } =
    api.terminal.getTerminals.useQuery(undefined, {
      initialData: [],
    });

  const { setLoadingStage } = useLoadingStore(
    useShallow((state) => ({
      setLoadingStage: state.setCurrentLoadingStage,
    })),
  );

  useEffect(() => {
    if (isTerminalsLoading) {
      setLoadingStage("tables");
    } else {
      setLoadingStage(undefined);
    }
  }, [isTerminalsLoading, setLoadingStage]);

  const context = {
    terminals,
  };

  return (
    <TerminalContext.Provider value={context}>
      {children}
    </TerminalContext.Provider>
  );
}
